import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=5275fbde&"
import script from "./QuestionDetail.vue?vue&type=script&lang=js&"
export * from "./QuestionDetail.vue?vue&type=script&lang=js&"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports